import Vue from 'vue'
import Vuex from 'vuex'
import AdminLevelStorage from './adminLevelStorage.js'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    token:null,
    user:null,
  },
  mutations: {
    setToken(state,data){
      state.token = data
      window.sessionStorage.setItem("token",data)
    },
    login(state,data){
      state.user = data
      window.sessionStorage.setItem("user",JSON.stringify(data))
      const admin_level = data?.admin_level || 0;
      AdminLevelStorage.save(admin_level);
    },
    logout(state){
      state.user = null
      state.token = null
      window.sessionStorage.removeItem("token")
      window.sessionStorage.removeItem("user")
      AdminLevelStorage.clear();
    },
  },
  getters:{
    getToken(state){
      return state.token || window.sessionStorage.getItem("token")
    },
    getUser(state){
      return state.user || JSON.parse( window.sessionStorage.getItem("user") )
    },
    getAdminLevel(state){
      return state?.admin_level || AdminLevelStorage.load() || 0;
    },
    isTheHighestLevel(state,getters){
      return getters.getAdminLevel >= 9;
    },
  },
  actions: {
  },
  modules: {
  }
})
